import store from 'utils/store/withMiddleware'

import querySelectorAll from 'utils/DOM/querySelectorAll'
import parsePlanPeriod from 'utils/pivot/plan/period/parsePlanPeriod'
import fitPlanConfigurationForFilter from '../utils/fitPlanConfigurationForFilter'
import { propAccessor } from '@hc-frontend/utils'

const getValue = node => node.value

function updateFilters() {
  const name = this.name
  const { filters, filtersByProductType, defaultFiltersByProductType } = store.getState()

  window.dataLayerPushEvent(
    `FILTER_GLOBAL_QUOTES-${name.toUpperCase()}-${this.value.toUpperCase()}`
  )

  const value = this.checked ? this.value : undefined

  if (name === 'coverage' || name === 'deductible') {
    filters[name] = { min: value, max: value }

    Object.keys(filtersByProductType).forEach(productType => {
      if (value) {
        filtersByProductType[productType] = {
          ...filtersByProductType[productType],
          [name]: value ? value : defaultFiltersByProductType[productType][name]
        }

        filtersByProductType[productType] = fitPlanConfigurationForFilter({
          planTypeKey: productType,
          filters: [{ filterName: name, filterValue: value }],
          filtersByProductType
        }).planFilter
      } else {
        if (!defaultFiltersByProductType[productType]) {
          filtersByProductType[productType] = undefined
        } else {
          Object.keys(defaultFiltersByProductType[productType]).forEach(filter => {
            filtersByProductType[productType][filter] =
              defaultFiltersByProductType[productType][filter]
          })
        }
      }
    })
    store.update({
      filters,
      filtersByProductType
    })
  } else if (name === 'period') {
    const planPeriod = parsePlanPeriod(value)

    const period = planPeriod ? planPeriod.period : undefined
    const policies = planPeriod ? planPeriod.policies : undefined

    Object.keys(filtersByProductType).forEach(productType => {
      filtersByProductType[productType] = {
        ...filtersByProductType[productType],
        period: period
          ? period
          : propAccessor(defaultFiltersByProductType, [productType, 'period']),
        policies: policies
          ? policies
          : propAccessor(defaultFiltersByProductType, [productType, 'policies'])
      }
    })

    store.update({
      filters: { ...filters, period, policies },
      filtersByProductType
    })
  } else {
    const nodes = Array.from(querySelectorAll(`[name="${name}"]:checked`))

    const mapper = getValue
    const values = nodes.map(mapper)
    filters[name] = values

    store.update({ filters })
  }
}

export default updateFilters
